import { Badge, styled } from "@mui/material";
export const BadgeStyledComponent = styled(Badge)(({ invisible, theme }) => {
    return {
        "& .MuiBadge-badge": {
            right: "50%",
            bottom: "6px",
            border: invisible ? undefined : `4px solid ${theme.palette.primary.main}`,
        },
    };
});
